module.exports = __webpack_public_path__ + "img/1.7878b9b0.jpeg";